var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "full-width no-padding-top", attrs: { id: "referral" } },
    [
      _c("div", { staticClass: "container" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12" }, [
            _c("div", { attrs: { id: "referral-wrapper" } }, [
              _c("div", { attrs: { id: "code" } }, [
                _vm._v(_vm._s(_vm.code ? _vm.code : "loading"))
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "This is your code - if your friends enter this in the checkout you'll be credited."
                )
              ]),
              _vm._v(" "),
              _c("div", [
                _vm._v("Your credit is "),
                _c("strong", [
                  _vm._v(
                    _vm._s(_vm.credit !== null ? "$" + _vm.credit : "loading")
                  )
                ])
              ])
            ])
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("h2", [_vm._v("Refer a friend")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Share the unique code below and we'll credit your account $20 for each signup - and they'll get 20% off!"
          )
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }